export enum InfoTypeEnum {
  Who = 'Who',
  What = 'What',
  When = 'When',
  Where = 'Where',
}
